import { WithdrawalUnfinishedTransactionItemStyled } from "./styled/WithdrawalUnfinishedTransactionStyled";
import { IWaitingWithdrawal } from "./WaitingWithdrawalConstants";
import BinIcon from "../../../../components/icon/IconWrapped";
import React, { useMemo } from "react";
import { Button } from "react-bootstrap";
import getPaymentMethodIcon from "../../../Deposit/utils/getPaymentMethodIcon";
import amountFormat from "../../../../utils/amountFormat";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";

interface IWithdrawalUnfinishedTransactionItemProps {
    item: IWaitingWithdrawal,
    onCancelClick: React.MouseEventHandler<HTMLButtonElement>,
}

export default function WithdrawalUnfinishedTransactionItem(props: IWithdrawalUnfinishedTransactionItemProps) {
    const { getLangPath } = useLangContext();

    const {
        item,
        onCancelClick,
    } = props;

    const paymentMethodIcon = useMemo(() => {
        return getPaymentMethodIcon(item.payment_key);
    }, [item.payment_key]);

    return <WithdrawalUnfinishedTransactionItemStyled>
        <div className={'flex-1 d-flex flex-column'}>
            <span className={'text-secondary f14 fw600'}>
                <BinIcon name={'IcClock'}
                         size={'16px'}
                         style={{ fill: 'var(--color-label-secondary)' }}/> {getLangPath('withdrawal.unfinished_transaction.title')}
            </span>
            <div className={'f16 fw600 mt-2 d-flex gap-2'}>
                {paymentMethodIcon && <BinIcon name={paymentMethodIcon}/>}
                <span>{item.currency}</span>
                <span>{amountFormat(item.amount)}</span>
            </div>
        </div>
        <div>
            <Button variant={'secondary'} size={'sm'} onClick={onCancelClick}
                    data-uuid={item.uuid}>{getLangPath('withdrawal.unfinished_transaction.cancel')}</Button>
        </div>
    </WithdrawalUnfinishedTransactionItemStyled>
}
